import React
    from 'react'
import './bouncingWordsMessage.css'
import Title from "../title/title"

const ThankYouMessage = ({message}) => {
    return (
        <div className={"thankYouWrapper"}>
            <Title className={"thankYouMessage"} text={message} />
        </div>
    )
}

export default ThankYouMessage
